import { useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { Button, Card, CardContent, Input, Label } from '@werkstatt/ui';
import api from '../../lib/api';
import { readApiError } from '../../lib/apiError';
import { useAuthStore } from '../../store/authStore';

export function ProfileTab() {
  const { user, refreshUser } = useAuthStore();
  const [form, setForm] = useState({ first_name: '', last_name: '', phone: '' });

  useEffect(() => {
    setForm({
      first_name: user?.first_name ?? '',
      last_name: user?.last_name ?? '',
      phone: user?.phone ?? '',
    });
  }, [user]);

  const saveMutation = useMutation({
    mutationFn: async () => (await api.put('/auth/me', form)).data,
    onSuccess: async () => {
      toast.success('Profil gespeichert');
      await refreshUser();
    },
    onError: (error: unknown) => toast.error(readApiError(error, 'Speichern fehlgeschlagen')),
  });

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    saveMutation.mutate();
  };

  return (
    <Card variant="glass">
      <CardContent className="p-6">
        <form onSubmit={handleSubmit} className="space-y-4 max-w-md">
          <div className="space-y-2">
            <Label htmlFor="profile-email">E-Mail</Label>
            <Input id="profile-email" value={user?.email ?? ''} disabled />
            <p className="text-xs text-muted-foreground">
              Die E-Mail-Adresse kann hier nicht geändert werden.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="profile-first-name">Vorname</Label>
              <Input
                id="profile-first-name"
                value={form.first_name}
                onChange={(e) => setForm({ ...form, first_name: e.target.value })}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="profile-last-name">Nachname</Label>
              <Input
                id="profile-last-name"
                value={form.last_name}
                onChange={(e) => setForm({ ...form, last_name: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="profile-phone">Telefon</Label>
            <Input
              id="profile-phone"
              value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
            />
          </div>

          <Button type="submit" disabled={saveMutation.isPending}>
            {saveMutation.isPending ? 'Wird gespeichert…' : 'Speichern'}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
